import React, {useState} from 'react';
import {Checkbox, Col, DatePicker, Input, InputNumber, message, Modal, Radio, Row, Select, Switch, Tag} from 'antd';
import dayjs from "dayjs";
import {calculateTotal} from "../../_helpers/calculateTotal";
import style from '../styles/expenses.periodic.module.css'

const AddOneExpenseModal = ({
                                visible,
                                onCancel,
                                onSave,
                                categories,
                                title = "Добавить разовый расход",
                                initialValues,
                            }) => {

    const defaultData = {
        name: initialValues ? initialValues.name : '',
        description: initialValues ? initialValues.description : '',
        category: initialValues ? initialValues.category : null,
        amount: initialValues ? initialValues.amount : null,
        paymentType: initialValues ? initialValues.isCash : true,
        tax: initialValues ? initialValues.tax : 21,
        date: initialValues ? dayjs(initialValues.date, 'YYYY-MM-DD') : dayjs(),
    }

    const defaultValidate = {
        name: true,
        category: true,
        amount: true,
        paymentType: true,
        tax: true,
        date: true,
    }

    const [data, setData] = useState(defaultData);                              // default data
    const [validate, setValidate] = useState(defaultValidate);                  // validate status
    const [inputMode, setInputMode] = useState('withoutTax');        // tax view
    const [zeroTaxChecked, setZeroTaxChecked] = useState(initialValues?.tax === 0 || initialValues?.tax === '0.00'); // tax 0

    const calculateAmountWithoutTax = (amountWithTax, taxRate) => {
        if (!amountWithTax || taxRate === 0) return amountWithTax;
        return amountWithTax / (1 + taxRate / 100);
    };

    const calculateAmountWithTax = (amountWithoutTax, taxRate) => {
        if (!amountWithoutTax || taxRate === 0) return amountWithoutTax;
        console.log(amountWithoutTax);
        console.log(+amountWithoutTax * (1 + taxRate / 100))
        return +amountWithoutTax * (1 + taxRate / 100);
    };

    const updateData = (field, value) => {
        const newData = {...data, [field]: value};
        setData(newData);
    }

    const handleAmountChange = (value) => {
        const newValue = value === null || value === undefined ? null : value;
        let newAmount = newValue;
        if (inputMode === 'withTax') {
            newAmount = newValue !== null ? calculateAmountWithoutTax(newValue, data.tax) : null;
        }
        updateData('amount', newAmount);
    };
    const handleTaxChange = (value) => {
        if (zeroTaxChecked) {
            updateData('tax', 0);
        } else {
            updateData('tax', value);
        }
    };

    const handleModeChange = (checked) => {
        const newMode = checked ? 'withTax' : 'withoutTax';
        setInputMode(newMode);
    };

    const handleZeroTaxChange = (e) => {
        const isChecked = e.target.checked;
        setZeroTaxChecked(isChecked);
        if (isChecked) {
            // Если включаем "НДС 0%", устанавливаем налог в 0
            updateData('tax', 0);
        } else {
            // Если выключаем, возвращаем стандартное значение 21%
            updateData('tax', 21);
        }
    };

    const getDisplayAmount = () => {
        if (inputMode === 'withTax') {
            return data.amount !== null ? calculateAmountWithTax(data.amount, data.tax).toFixed(2) : null;
        }
        return data.amount;
    };


    const findCategoryById = (id) => {
        return categories.find(cat => String(cat.id) === String(id));
    };

    const CategoryDisplay = ({value}) => {
        const category = findCategoryById(value);
        if (!category) {
            return <span>Выберите категорию</span>;
        }
        return <Tag color={category.color}>{category.name}</Tag>;
    };

    const validateData = (formData) => {
        const newValidate = {...validate};
        let isValid = true;

        if (!formData.name || formData.name.trim() === '') {
            newValidate.name = false;
            isValid = false;
        } else {
            newValidate.name = true;
        }

        if (!formData.category_id || formData.category_id === '') {
            newValidate.category = false;
            isValid = false;
        } else {
            newValidate.category = true;
        }

        if (!formData.date || formData.date === '') {
            newValidate.date = false;
            isValid = false;
        } else {
            newValidate.date = true;
        }

        if (!formData.amount || formData.amount <= 0) {
            newValidate.amount = false;
            isValid = false;
        } else {
            newValidate.amount = true;
        }

        newValidate.paymentType = true;

        if (formData.isCash === false) {
            if (formData.tax_rate === undefined || formData.tax_rate === null || formData.tax_rate < 0) {
                newValidate.tax = false;
                isValid = false;
            } else {
                newValidate.tax = true;
            }
        } else {
            newValidate.tax = true;
        }

        setValidate(newValidate);
        return isValid;
    };

    const handleSubmit = () => {
        const formData = {
            id: data.id,
            name: data.name,
            description: data.description,
            category_id: data.category,
            amount: data.amount,
            isCash: data.paymentType,
            tax_rate: data.tax,
            date: dayjs(data.date).format('DD.MM.YYYY'),
        };
        if (validateData(formData)) {
            onSave(formData);
        } else {
            message.error('Не заполнены обязательные поля');
        }
    };

    // Вычисляем итоговую сумму для отображения
    const calculateFinalAmount = () => {
        if (!data.amount) return '0.00';
        if (data.paymentType) {
            return data.amount.toFixed(2);
        } else {
            if (data.tax === 0) {
                return data.amount.toFixed(2);
            }
            return calculateTotal(data.amount, data.tax, false).toFixed(2);
        }
    };

    return (
        <Modal
            title={title}
            open={visible}
            onOk={handleSubmit}
            onCancel={onCancel}
            width={600}
            okText="Сохранить"
            cancelText="Отмена"
            forceRender={true}
        >
            <div className={style.name_field}><span style={{color: 'red'}}>*</span> Наименование</div>
            <Input placeholder="Введите наименование расхода"
                   value={data.name}
                   onChange={v => updateData('name', v.target.value)}
                   status={!validate.name ? 'error' : 'success'}
            />

            <div className={style.name_field}><span style={{marginLeft: '10px'}}>Описание статьи расходов</span></div>
            <Input placeholder="Введите описание статьи расходов (не обязательно)" value={data.description}
                   onChange={v => updateData('description', v.target.value)}/>

            <div className={style.name_field}><span style={{color: 'red'}}>*</span> Категория</div>
            <Select placeholder="Выберите категорию расходов"
                    options={categories.map(category => ({value: +category.id, label: category.name}))}
                    defaultValue={data.category}
                    optionRender={option => (
                        <CategoryDisplay value={option.value}/>
                    )}
                    onChange={v => updateData('category', v)}
                    style={{width: '100%'}}
                    status={!validate.category ? 'error' : 'success'}
            />

            <div className={style.cont_of_dates}>
                <div>
                    <div className={style.name_field}><span style={{color: 'red'}}>*</span> Дата списания</div>
                    <DatePicker format="DD.MM.YYYY"
                                style={{width: '100%'}}
                                defaultValue={data.date}
                                onChange={date => updateData('date', date)}
                                status={!validate.date ? 'error' : 'success'}
                    />
                </div>
            </div>

            <div className={style.name_field}><span style={{color: 'red'}}>*</span> Тип платежа</div>
            <Radio.Group
                onChange={e => updateData('paymentType', e.target.value)}
                value={data.paymentType}>
                <Radio value={true}>Наличный</Radio>
                <Radio value={false}>Безналичный</Radio>
            </Radio.Group>

            {!data.paymentType && (
                <>
                    <div style={{marginBottom: '16px'}}>
                        <div className={style.name_field}>Данный платеж без НДС?</div>
                        <Checkbox
                            checked={zeroTaxChecked}
                            onChange={handleZeroTaxChange}
                        >
                            без НДС
                        </Checkbox>
                    </div>
                    {!zeroTaxChecked &&
                        <div style={{marginTop: '16px', marginBottom: '8px'}}>
                            <div className={style.name_field}>Вы хотите указать цену с НДС или без?</div>
                            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                                <Switch
                                    checked={inputMode === 'withTax'}
                                    onChange={handleModeChange}
                                    checkedChildren="С НДС"
                                    unCheckedChildren="Без НДС"
                                />
                            </div>
                        </div>}
                </>
            )}

            <div className={style.cont_of_ammount}>
                <div style={{marginRight: '10px', flex: 1}}>
                    <div className={style.name_field}>
                        <span style={{color: 'red'}}>*</span>
                        {data.paymentType && 'Сумма'}
                        {zeroTaxChecked && 'Сумма'}
                        {!data.paymentType && inputMode === 'withTax' && !zeroTaxChecked && 'Сумма с НДС'}
                        {!data.paymentType && inputMode !== 'withTax' && !zeroTaxChecked && 'Сумма без НДС'}
                    </div>
                    <InputNumber
                        min={0}
                        step={0.01}
                        value={getDisplayAmount()}
                        status={!validate.amount ? 'error' : 'success'}
                        onChange={handleAmountChange}
                        style={{width: '100%'}}
                        parser={(value) => {
                            if (!value) return null;
                            return parseFloat(value.replace(',', '.'));
                        }}
                    />

                </div>
                <div>
                    {!data.paymentType &&
                        <>
                            <div className={style.name_field}><span style={{color: 'red'}}>*</span> НДС</div>
                            <InputNumber
                                value={data.tax}
                                min={0}
                                max={100}
                                disabled={zeroTaxChecked} // Отключаем поле если НДС 0%
                                status={!validate.tax ? 'error' : 'success'}
                                step={0.1}
                                style={{width: '100%'}}
                                addonAfter="%"
                                onChange={handleTaxChange}
                                parser={(value) => {
                                    if (!value) return null;
                                    return parseFloat(value.replace(',', '.'));
                                }}
                            />
                        </>
                    }
                </div>

            </div>
            {!data.paymentType && inputMode === 'withTax' && data.amount && !zeroTaxChecked && (
                <div style={{margin: '10px', fontSize: '12px', color: '#666', minHeight: '20px'}}>
                    Без НДС: € {data.amount.toFixed(2)}
                </div>
            )}
            <div className={style.name_field}>
                <Row style={{marginBottom: 16, padding: '8px', background: '#d0f3ce', borderRadius: '4px'}}>
                    <Col span={12}>
                        {data.paymentType && <strong>Итого:</strong>}
                        {!data.paymentType && zeroTaxChecked && <strong>Итого:</strong>}
                        {!data.paymentType && !zeroTaxChecked && <strong>Итого с НДС:</strong>}
                    </Col>
                    <Col span={12} style={{textAlign: 'right'}}>
                        <strong>
                            € {calculateFinalAmount()}
                        </strong>
                    </Col>
                </Row>
                {!data.paymentType && zeroTaxChecked && (
                    <Row style={{marginBottom: 16, padding: '8px', background: '#fff3cd', borderRadius: '4px'}}>
                        <Col span={24} style={{textAlign: 'center', color: '#856404'}}>
                            <strong>⚠️ Безналичный платеж (НДС не начисляется)</strong>
                        </Col>
                    </Row>
                )}
            </div>
        </Modal>
    );
};

export default AddOneExpenseModal;